"use client";
import React, { useState, useContext, useEffect } from "react";
import { RecentLeaderContext } from "@/components/server/RecentLeaderBoardContainer/context";
import { Image } from "@/lib/target";
import { Checkbox } from "@nextui-org/react";

const TeamSection = ({ isHome, team, total, totalRate, winLossRate, handicapRate, overUnderRate }) => {
  const {
    toogleHomeCheck,
    setHalfTimeChecked,
    filteMatchesByLength,
    filteMatchesByLeague,
  } = useContext(RecentLeaderContext);

  const [homeCheck, setHomeCheck] = useState(false);
  const handleToogleHomeCheck = () => {
    setHomeCheck((prev) => !prev);
    toogleHomeCheck(team.id, !homeCheck);
  };

  const [matchHalfTimeChecked, setMatchHalfTimeChecked] = useState(false);
  const handleToogleHalfTimeCheck = () => {
    setMatchHalfTimeChecked((prev) => !prev);
    setHalfTimeChecked(team.id, !matchHalfTimeChecked);
  };

  const [sameLeagueChecked, setSameLeagueChecked] = useState(false);
  const handleToogleSameLeagueCheck = () => {
    setSameLeagueChecked((prev) => !prev);
    filteMatchesByLeague(team.id, !sameLeagueChecked);
  };

  const [matchesNumber, setMatchesNumber] = useState(total);

  useEffect(() => {
    setMatchesNumber(total);
  }, [total]);

  const handleChangeMatchesNumber = (e) => {
    setMatchesNumber(Number(e.target.value));
    filteMatchesByLength(team.id, Number(e.target.value));
  };

  return (
    <div className={"grid grid-cols-1 lg:grid-cols-2 gap-8"}>
      <div className={"flex flex-col justify-between gap-5 p-1"}>
        <div
          className={
            "flex flex-row justify-items-start items-start gap-5 @md:px-[31px] mt-2"
          }
        >
          <div className={"w-2/12"}>
            <Image
              src={team.logo}
              alt={team.name}
              width={64}
              height={64}
              className={"w-16 h-16"}
            />
          </div>
          <div className={"w-10/12"}>
            <div className={"text-dark-gray dark:text-stroke-o3 text-sm"}>{team.name}</div>
            <div className={"flex flex-row justify-items-start items-start"}>
              <div
                className={
                  "w-3/12 flex flex-col justify-items-start items-start gap-1"
                }
              >
                <Checkbox
                  color={"default"}
                  className={"!text-xxs"}
                  radius={"none"}
                  children={"text-xxs"}
                  size={"sm"}
                  value={homeCheck}
                  onChange={handleToogleHomeCheck}
                >
                  Chủ
                </Checkbox>
                <Checkbox
                  color={"default"}
                  className={"!text-xxs"}
                  radius={"none"}
                  children={"text-xxs"}
                  size={"sm"}
                  value={matchHalfTimeChecked}
                  onChange={handleToogleHalfTimeCheck}
                >
                  HT
                </Checkbox>
              </div>
              <div
                className={
                  "w-9/12 flex flex-col justify-items-start items-start gap-1"
                }
              >
                <Checkbox
                  color={"default"}
                  className={"!text-xxs"}
                  radius={"none"}
                  children={"text-xxs"}
                  size={"sm"}
                  value={sameLeagueChecked}
                  onChange={handleToogleSameLeagueCheck}
                >
                  Giải đấu tương đồng
                </Checkbox>

                <select
                  className={
                    "w-full bg-[#D9D9D9] max-w-[128px] border-1 border-solid border-black text-dark-gray"
                  }
                  value={matchesNumber}
                  onChange={handleChangeMatchesNumber}
                >
                  {Array.from({ length: total }).map((_, index) => (
                    <option value={index + 1} key={index}>
                      {index + 1} trận gần nhất
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className={"flex flex-col gap-3"}>
          <div className={"flex flex-col"}>
            <div
              className={"flex flex-row justify-between items-center text-xs"}
            >
              <div
                className={"text-button-blue-bet dark:text-stroke-o3"}
              >{`Thắng ${winLossRate.win} (${winLossRate.winRate}%  )`}</div>
              <div
                className={"text-[#8C8C8C] dark:text-stroke-o3"}
              >{`Hoà ${winLossRate.draw} (${winLossRate.drawRate}%)`}</div>
              <div
                className={"text-[#8C8C8C] dark:text-stroke-o3"}
              >{`Bại ${winLossRate.loss} (${winLossRate.lossRate}%)`}</div>
            </div>
            <div
              className={
                "bg-[#8C8C8C] w-full h-[15px] flex justify-start rounded"
              }
            >
              <div
                className={`${isHome ? "bg-button-blue-bet" : "bg-[#ffc739]"} rounded-bl rounded-tl`}
                style={{ width: `${winLossRate.winRate}%` }}
              ></div>
            </div>
          </div>
          <div className={"flex flex-col"}>
            <div
              className={"flex flex-row justify-between items-center text-xs"}
            >
              <div className={"text-button-blue-bet dark:text-stroke-o3"}>{`${winLossRate.totalGoalRatio} Bàn`}</div>
              <div className={"text-[#8C8C8C] dark:text-stroke-o3"}>Ghi/Mất bàn mỗi trận</div>
              <div className={"text-[#8C8C8C] dark:text-stroke-o3"}>{`${winLossRate.totalGoalConcededRatio} Bàn`}</div>
            </div>
            <div
              className={
                "bg-[#8C8C8C] w-full h-[15px] flex justify-start rounded"
              }
            >
              <div
                className={`${isHome ? "bg-button-blue-bet" : "bg-[#ffc739]"} rounded-bl rounded-tl`}
                style={{ width: `${winLossRate.totalGoalRatio}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className={"flex flex-col gap-2 p-1"}>
        <div className={"text-dark-gray dark:text-stroke-o3 text-sm font-semi-bold"}>
          Tỷ lệ Châu Á ({totalRate} Trận)
        </div>
        <div className={"flex flex-col"}>
          <div className={"flex flex-row justify-start items-center gap-6"}>
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Chủ</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-button-blue-bet rounded-bl rounded-tl"}
                style={{ width: `${handicapRate?.winRate === '0' ? '1' : handicapRate?.winRate}%` }}
              ></div>
              <div
                className={"text-button-blue-bet text-xs font-semi-bold p-1"}
              >
                {`${handicapRate?.winRate}%`}
              </div>
            </div>
          </div>
          <div
            className={
              "flex flex-row justify-start items-center gap-6 mt-[5px]"
            }
          >
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Hoà</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-[#6abc53] rounded-bl rounded-tl"}
                style={{ width: `${handicapRate?.drawRate === '0'? '1' : handicapRate?.drawRate}%` }}
              ></div>
              <div className={"text-[#6abc53] text-xs font-semi-bold p-1"}>
                {`${handicapRate?.drawRate}%`}
              </div>
            </div>
          </div>
          <div
            className={
              "flex flex-row justify-start items-center gap-6 mt-[5px]"
            }
          >
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Khách</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-[#ffc739] rounded-bl rounded-tl"}
                style={{ width: `${handicapRate?.lossRate === '0' ? '1' : handicapRate?.lossRate}%` }}
              ></div>
              <div className={"text-[#ffc739] text-xs font-semi-bold p-1"}>
                {`${handicapRate?.lossRate}%`}
              </div>
            </div>
          </div>
        </div>
        <div className={"text-dark-gray dark:text-stroke-o3 text-sm font-semi-bold"}>
          Tỷ lệ tài xỉu ({totalRate} Trận)
        </div>
        <div className={"flex flex-col"}>
          <div className={"flex flex-row justify-start items-center gap-6"}>
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Chủ</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-button-blue-bet rounded-bl rounded-tl"}
                style={{ width: `${overUnderRate?.winRate === '0' ? '1' : overUnderRate?.winRate}%` }}
              ></div>
              <div
                className={"text-button-blue-bet text-xs font-semi-bold p-1"}
              >
                {`${overUnderRate?.winRate}%`}
              </div>
            </div>
          </div>
          <div
            className={
              "flex flex-row justify-start items-center gap-6 mt-[5px]"
            }
          >
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Hoà</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-[#6abc53] rounded-bl rounded-tl"}
                style={{ width: `${overUnderRate?.drawRate === '0' ? '1' : overUnderRate?.drawRate}%` }}
              ></div>
              <div className={"text-[#6abc53] text-xs font-semi-bold p-1"}>
                {`${overUnderRate?.drawRate}%`}
              </div>
            </div>
          </div>
          <div
            className={
              "flex flex-row justify-start items-center gap-6 mt-[5px]"
            }
          >
            <div className={"text-dark-gray dark:text-stroke-o3 w-2/12"}>Khách</div>
            <div
              className={
                `w-full h-6 rounded flex flex-row  gap-2 w-10/12`
              }
            >
              <div
                className={"bg-[#ffc739] rounded-bl rounded-tl"}
                style={{ width: `${overUnderRate?.lossRate === '0' ? '1' : overUnderRate?.lossRate}%` }}
              ></div>
              <div className={"text-[#ffc739] text-xs font-semi-bold p-1"}>
                {`${overUnderRate?.lossRate}%`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
